import { useConnectionState } from '../../hooks/useBLE';
import StatusBadge from '../shared/StatusBadge';

export default function ConnectionBadge() {
  const state = useConnectionState();
  return <StatusBadge state={state} />;
}
